module.exports = __webpack_public_path__ + "img/qg-main.afaf667b.jpg";